module.exports = __webpack_public_path__ + "static/media/ic_video.c05be2e1.svg";